// What this build can actually start, independent of what the server
// advertises. A provider belongs here only once its backend start route exists:
// rendering a button the backend would answer with 404 PROVIDER_DISABLED is a
// dead end for the user.
//
// Phase 9 adds Google. Apple is Phase 10 and stays out until
// /api/auth/start/apple exists.
const STARTABLE_AUTH_PROVIDERS = new Set(["google", "email"]);

export const AUTH_PROVIDER_LABELS = Object.freeze({
  google: "Google",
  apple: "Apple",
  email: "Email",
});

export function getStartableAuthProviders(providers) {
  if (!Array.isArray(providers)) {
    return [];
  }
  return providers.filter((providerId) => STARTABLE_AUTH_PROVIDERS.has(providerId));
}

export function isStartableAuthProvider(providerId) {
  return STARTABLE_AUTH_PROVIDERS.has(providerId);
}

export function getAuthProviderLabel(providerId) {
  return AUTH_PROVIDER_LABELS[providerId] || null;
}
